module.exports = __webpack_public_path__ + "img/PatrickHaberzettl_140x140_rund.3f3fb500.jpg";